import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { birchmountGiftCardOperation } from 'actions/EntityActions';
import { formInput } from 'actions/FormActions';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import RadioInput from 'screens/components/basic/RadioInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import LOOKUP from 'constants/lookup';


class BirchmountGiftCardActivation extends Component {
    constructor(props, context) {
        super(props, context);
    }

    activation = () => {
        let p = this.props;
        if (!p.type) {
            alert(this.props.t('pos.birchmountGiftCard.activation.selectActivation'));
            return;
        } else {
            let model = {
                BranchId: p.branchId,
                CardNumber: p.cardNumber,
                Operations: p.type == '1' ? LOOKUP.BirchmountGiftCardOperationType.Activation : LOOKUP.BirchmountGiftCardOperationType.Reload,
                Amount: p.amount
            };
            this.props.birchmountGiftCardOperation(model);
        }
    }
    
    render() {
        const { t } = this.props; 
        let p = this.props;
        const options = [
            {
                text: t('pos.birchmountGiftCard.activation.activation'),
                value: '1'
            },
            {
                text: t('pos.birchmountGiftCard.activation.reload'),
                value: '2'
            }
        ];

        return (
            <DialogInput
                title={<DialogHeaderWithClose text={t('pos.giftCard.activation.label')} classicClass="posDialogClassic" handleClose={() => this.props.onCancel()} />}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space btnNewBrandPOS"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.activation()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                <div>
                    <h4>{t('pos.birchmountGiftCard.activation.fillInfoToActivate')}</h4>
                    <div className="row">
                        <div className="col-lg-12">
                            <RadioInput
                                groupName={`${p.name}type`}
                                options={options}
                                className="rdBtnLabels"
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}CardNumber`}
                                fullWidth={true}
                                label={t('common.cardNum')}
                                floatingLabelText={t('common.cardNum')}
                                hintText={t('common.cardNum')} />
                        </div>
                        <div className="col-lg-12">
                            <DecimalInput name={`${p.name}Amount`}
                                fullWidth={true}
                                label={t('pos.birchmountGiftCard.activation.activationReloadAmount')}
                                disabled={p.birchmountActivationFromSale}
                                floatingLabelText={t('pos.birchmountGiftCard.activation.activationReloadAmount')}
                                hintText={t('pos.birchmountGiftCard.activation.activationReloadAmount')} />
                        </div>
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        cardNumber: state.form[`BirchmountGiftCardActivationCardNumber`] || '',
        amount: state.form['BirchmountGiftCardActivationAmount'] || 0,
        type: state.form[`BirchmountGiftCardActivationtype`] || ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        birchmountGiftCardOperation: (model) => dispatch(birchmountGiftCardOperation(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BirchmountGiftCardActivation));